export const SIGNIN = 'SIGNIN';
export const SIGNUP = 'SIGNUP';
export const AUTH_RESULT = 'AUTH_RESULT';